import {GET_DOCUMENT_OBTAINING} from "../../../enums/Request/request.types";

export const layoffDismissalDocumentObtainingAction = (data) => {
    return {
        type: GET_DOCUMENT_OBTAINING,
        payload: data,
    };
};
